import React from 'react';
import { createStandaloneToast } from '@chakra-ui/toast';

import Toast from '../components/Toast';
import pinsTheme from '../styles/theme';

export const { ToastContainer, toast } = createStandaloneToast({ theme: pinsTheme });

/**
 * createToast
 *
 * Renders a custom Chakra toast component to show a toast based on the status param. Will default to
 * 'general.'
 *
 * @param toastInstance
 * @param {string} title
 * @param {string} description
 * @param {string} size
 * @param {string} status
 * @param {bool} isClosable
 * @param {string} position
 * @param {number} duration
 *
 * @returns void
 */

export const createToast = ({
  position = 'bottom',
  title,
  description = null,
  size = 'lg',
  status = 'general',
  isClosable,
  duration = 9000
}) => {
  toast.closeAll();

  toast({
    duration,
    position,
    render: props => (
      <Toast
        description={description}
        isClosable={isClosable}
        size={size}
        status={status}
        title={title}
        {...props}
      />
    )
  });
};
